import { render, staticRenderFns } from "./topThree.vue?vue&type=template&id=f1a1a82c&scoped=true"
import script from "./topThree.vue?vue&type=script&lang=js"
export * from "./topThree.vue?vue&type=script&lang=js"
import style0 from "./topThree.vue?vue&type=style&index=0&id=f1a1a82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a1a82c",
  null
  
)

export default component.exports